/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Row,
	Spinner,
} from 'native-base';
import ScreenContainer from './ScreenContainer';

export default function Loading(props) {
	if (props.isScreen) {
		return <ScreenContainer {...props}>
					<Spinner flex={1} color="primary.500" />
				</ScreenContainer>;
	}
	return <Row justifyContent="center" minHeight={100} {...props}>
				<Spinner flex={1} color="primary.500" />
			</Row>;
}
